import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Template from '../entities/template';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import Axios from 'axios';

interface TemplateState extends ListState<Template> {
    editTemplate: Template;
    isloadingindex:boolean;
}
class TemplateModule extends ListModule<TemplateState, any, Template> {
    public state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Template>(),
        loading: false,
        editTemplate: new Template(),
        isloadingindex:false,
    };
    public actions = {
        async getAll(context: ActionContext<TemplateState, any>, payload: any) {
            context.state.loading = true;
            const reponse = await Ajax.get('/api/services/app/TemplateSetting/GetAll', { params: payload.data });
            context.state.loading = false;
            const page = reponse.data.result as PageResult<Template>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<TemplateState, any>, payload: any) {
            await Ajax.post('/api/services/app/TemplateSetting/Create', payload.data);
        },
        async update(context: ActionContext<TemplateState, any>, payload: any) {
            await Ajax.put('/api/services/app/TemplateSetting/Update', payload.data);
        },
        async delete(context: ActionContext<TemplateState, any>, payload: any) {
            await Ajax.delete('/api/services/app/TemplateSetting/Delete?Id=' + payload.data.id);
        },
        async get(context: ActionContext<TemplateState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/TemplateSetting/Get?Id=' + payload.data.id);
            return reponse.data.result as Template;
        },
        async getbytemplateclass(context: ActionContext<TemplateState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/TemplateSetting/GetByTemplateClass?templateClass=' + payload.data.templateClass);
            return reponse.data.result as Template;
        },
        async deleteselected(context: ActionContext<TemplateState, any>, payload: any) {
            await Ajax.delete('/api/services/app/TemplateSetting/DeleteSelected?inputs=' + payload.data.inputs);
        },
        async createdetail(context: ActionContext<TemplateState, any>, payload: any) {
            await Ajax.post('/api/services/app/TemplateDetail/CreateAll', payload.data); /*payload.data*/
        },
        async getdetailall(context: ActionContext<TemplateState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/TemplateDetail/GetAllTemplate?parentid=' + payload.data.parentid);
            return reponse.data.result;
        },
        async getusercenterdetailall(context: ActionContext<TemplateState, any>, payload: any) {
            //const reponse = await Ajax.get('/api/services/app/TemplateDetail/GetAllTemplatesOfUsercenterFromCache');
            let reponse = {temp1:{},temp2:{}};
            return await Axios.all([await Ajax.get('/api/services/app/TemplateDetail/GetAllTemplatesOfUsercenterFromCache'),await Ajax.get('/api/services/app/VipInfo/GetUserTempetRights')])
            .then(Axios.spread(function(acct, tasks){
                reponse.temp1=acct.data.result
                reponse.temp2=tasks.data.result
                return reponse;
            }))
           
        },
        async  getTemplatesIndexByBranchno(context: ActionContext<TemplateState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/TemplateDetail/GetAllTemplatesIndexByBranchnoCache', { params: payload.data });
            return reponse.data.result;
    },
        async getindexdetailall(context: ActionContext<TemplateState, any>, payload: any) {
            var templateId=payload.templateId==null|| payload.templateId==undefined?0:payload.templateId;
            const reponse = await Ajax.get('/api/services/app/TemplateDetail/GetAllTemplatesOfIndexFromCache?templateId='+templateId);
            return reponse.data.result;
        },
        async getshoppingcartdetailall(context: ActionContext<TemplateState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/TemplateDetail/GetAllTemplatesOfShoppingCartFromCache');
            return reponse.data.result;
        },
        async getpaycompletedetailall(context: ActionContext<TemplateState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/TemplateDetail/GetAllTemplatesOfPaycomplateFromCache');
            return reponse.data.result;
        },
        async getcurrentnavbar(context: ActionContext<TemplateState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Navbar/GetCurrentNavbar');
            return reponse.data.result;
        },
        async getBasicsetThemecolor(context: ActionContext<TemplateState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/BasicSet/GetBasicsetThemecolor');
            return reponse.data.result;
        },
    };
    public mutations = {
        setCurrentPage(state: TemplateState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: TemplateState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: TemplateState, template: Template) {
            state.editTemplate = template;
        },
        updateIndexState(state: TemplateState, indexstate: boolean) {
            state.isloadingindex = indexstate;
        },
    };
}
const templateModule = new TemplateModule();
export default templateModule;
